{% block sw_cms_preview_manufacturer_block %}
	<sw-cms-element-manufacturer-preview></sw-cms-element-manufacturer-preview>
{% endblock %}
